import React from "react";
import QueryString from "qs";
import { GetServerSideProps } from "next";
import LeadershipPage from "@/Components/pages/LeadershipPage";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { res } = ctx;

  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }

  let apiResData = null;
  const isNew = true;

  try {
    const query = QueryString.stringify(
      {
        filters: { slug: { $eq: "our-leadership" } },
        populate: "deep,5",
      },
      { encodeValuesOnly: true }
    );

    const apiRes = await fetch(`${baseUrl}our-leadership-teams?${query}`);
    const json = await apiRes.json();

    const service = json?.data?.[0];
    apiResData = service?.attributes ?? null;
  } catch (err) {
    console.error("Error fetching service data:", err);
    apiResData = null;
  }

  return {
    props: {
      apiResData,
      isNew,
    },
  };
};
interface LeadershipProps {
  apiResData: any;
}
const Leadership: React.FC<LeadershipProps> = ({ apiResData }) => {
  return (
    <div id="root">
      <LeadershipPage data={apiResData ?? {}} />
    </div>
  );
};

export default Leadership;
